export default "__VITE_ASSET__82faedc0__"